<template>
  <div class="login" :style="{ backgroundImage: `url(${game_id[info.appid || 3]?.bg})` }">
    <div class="border-bg gift-info">
      <div class="gift-img">
        <img v-for="item in game_id[info.appid || 3]?.imgList" :key="item.imgUrl" :src="item.imgUrl" alt="" />
      </div>
      <div class="gift-text rule">
        {{ game_id[info.appid || 3]?.imgText }}
      </div>
    </div>
    <div class="border-bg login-form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <el-form-item label="" prop="mobile">
          <div class="form-bg">
            <el-input v-model.trim="ruleForm.mobile" placeholder="phone" :readonly="is_bind">
              <template slot="prepend">84 - </template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item v-if="!is_bind">
          <el-col :span="16">
            <el-form-item prop="code">
              <div class="form-bg">
                <el-input v-model.trim="ruleForm.code" oninput="value=value.replace(/[^0-9.]/g,'')"
                  placeholder="Xin nhập OTP"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="7">
            <el-button class="getCode" type="primary" @click="getCode()">
              {{ codeTime > 0 ? codeTime : "Nhận OTP" }}
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" :disabled="is_bind && is_receive"
            v-loading.fullscreen.lock="fullscreenLoading" class="btn">
            {{ bindText }}
          </el-button>
        </el-form-item>
        <div class="rule">
          {{ game_id[info.appid || 3]?.rule }}
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
const shanghaiList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/8/1.png") },
    { imgUrl: require("../assets/img/gift/8/2.png") },
    { imgUrl: require("../assets/img/gift/8/3.png") },
    { imgUrl: require("../assets/img/gift/8/4.png") },
    { imgUrl: require("../assets/img/gift/8/5.png") },
  ],
  imgText:
    "Tiên Ngọc x100, Trứng Dị Thú x100, Tinh Kim x3, Vé Gia Tốc x5, Búa x10",
  bg: require("../assets/img/gift/8/bg.png"),
  rule: "Xin kiểm tra tin nhắn zalo để nhận mã xác thực; Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const lingzhuList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/12/1.png") },
    { imgUrl: require("../assets/img/gift/12/2.png") },
    { imgUrl: require("../assets/img/gift/12/3.png") },
    { imgUrl: require("../assets/img/gift/12/4.png") },
  ],
  imgText: "Xu Vàng x10000, KC Tuyết x100, Đục Băng x1, Chìa Mật Mở Khóa x50",
  bg: require("../assets/img/gift/12/bg.png"),
  rule: "Xin kiểm tra tin nhắn zalo để nhận mã xác thực; Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const yishouList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/18/1.png") },
    { imgUrl: require("../assets/img/gift/18/2.png") },
    { imgUrl: require("../assets/img/gift/18/3.png") },
    { imgUrl: require("../assets/img/gift/18/4.png") },
  ],
  imgText:
    "Tầm Bảo Lệnh*5, Thủy Tinh C.Hóa TB*2, 99 đóa Hồng Lam,Đan Long Huyết Cực*1",
  bg: require("../assets/img/gift/18/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const xiangrikuiList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/16/1.png") },
    { imgUrl: require("../assets/img/gift/16/2.png") },
    { imgUrl: require("../assets/img/gift/16/3.png") },
  ],
  imgText: "Kim Cương X 300, Vàng X 10000, Lá Cây Ma Thuật X 10",
  bg: require("../assets/img/gift/16/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const huayuanList = {
  imgList: [{ imgUrl: require("../assets/img/gift/29/1.png") }],
  imgText: "KNB X 100",
  bg: require("../assets/img/gift/29/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const fanxiuList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/32/1.png") },
    { imgUrl: require("../assets/img/gift/32/2.png") },
    { imgUrl: require("../assets/img/gift/32/3.png") },
    { imgUrl: require("../assets/img/gift/32/4.png") },
  ],
  imgText:
    "Tiên Ngọc X 50,Vé Triệu Hồi X 1,Mảnh Bí Bảo Thượng Phẩm X 20,Huyền Thiết Thần Luyện X 10",
  bg: require("../assets/img/gift/32/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const shouhuaList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/35/1.png") },
    { imgUrl: require("../assets/img/gift/35/2.png") },
    { imgUrl: require("../assets/img/gift/35/3.png") }
  ],
  imgText: "KNB x200, Thiệp Bái Tướng x5, Vé Tăng Tốc x10",
  bg: require("../assets/img/gift/35/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
const yanyuList = {
  imgList: [
    { imgUrl: require("../assets/img/gift/39/1.png") },
    { imgUrl: require("../assets/img/gift/39/2.png") },
    { imgUrl: require("../assets/img/gift/39/3.png") }
  ],
  imgText: "KNB x200, Thiệp Bái Tướng x5, Vé Tăng Tốc x10",
  bg: require("../assets/img/gift/39/bg.png"),
  rule: "Xin vui lòng kiểm tra tin nhắn SMS để nhận mã xác thực. Nếu bạn chưa nhận được mã xác thực, hãy gửi lại yêu cầu sau 60s!",
};
export default {
  name: "login",
  mixins: [],
  props: {},
  data() {
    return {
      codeTime: 0,
      ruleForm: {
        mobile: "",
        code: "",
      },
      rules: {
        mobile: [
          {
            required: true,
            message: "Xin nhập số điện thoại",
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "Xin nhập OTP", trigger: "blur" }],
      },
      info: {},
      bindText: "Liên kết và nhận",
      is_bind: false,
      is_receive: false,
      fullscreenLoading: false,
      game_id: {
        3: shanghaiList,
        8: shanghaiList,
        9: shanghaiList,
        14: shanghaiList,
        12: lingzhuList,
        13: lingzhuList,
        16: xiangrikuiList,
        17: xiangrikuiList,
        18: yishouList,
        19: yishouList,
        29: huayuanList,
        30: huayuanList,
        32: fanxiuList,
        33: fanxiuList,
        35: shouhuaList,
        36: shouhuaList,
        39: yanyuList,
        40: yanyuList,
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    this.info = this.$route.query;
    this.getData();
  },
  mounted() { },
  methods: {
    getData() {
      this.fullscreenLoading = true;
      let params = {
        appid: this.info.appid,
        userid: this.info.userid,
        token: this.info.token,
      };
      this.$http.post("/api/getUserBindInfo", params).then((res) => {
        if (res.code === 200) {
          this.ruleForm = res.data;
          let { is_bind, is_receive } = res.data;
          this.is_bind = is_bind ? true : false;
          this.is_receive = is_receive ? true : false;
          if (is_bind && is_receive) {
            this.bindText = "Đã nhận";
          } else if (!is_bind && !is_receive) {
            this.bindText = "Liên kết và nhận";
          } else if (is_bind && !is_receive) {
            this.bindText = "Nhận";
          }
          this.fullscreenLoading = false;
        } else {
          this.$message.error(res.msg);
          this.fullscreenLoading = false;
        }
      });
    },
    getCode() {
      if (this.ruleForm.mobile === "") {
        this.$message.warning("Xin nhập số điện thoại");
        return;
      }
      if (this.codeTime <= 59 && this.codeTime > 0) {
        return;
      }
      let params = {
        appid: this.info.appid,
        userid: this.info.userid,
        token: this.info.token,
        mobile: this.ruleForm.mobile,
      };
      this.$http.post("/api/sendMobileCode", params).then((res) => {
        if (res.code === 200) {
          this.codeTime = 59;
          let codeTimeInt = setInterval(() => {
            this.codeTime = this.codeTime - 1;
            if (this.codeTime == 0) {
              clearInterval(codeTimeInt);
            }
          }, 1000);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            appid: this.info.appid,
            userid: this.info.userid,
            token: this.info.token,
            mobile: this.ruleForm.mobile,
            code: this.ruleForm.code,
            server_id: this.info.server_id,
            role_id: this.info.role_id,
          };
          this.fullscreenLoading = true;
          this.$http.post("/api/bindMobileAndGift", params).then((res) => {
            if (res.code === 200) {
              this.getData();
              _this.$message.success(res.msg);
            } else {
              _this.$message.error(res.msg);
            }
            this.fullscreenLoading = false;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-input {
  width: 99%;
}

/deep/ .el-input__inner {
  border: none;
  background-color: transparent;
}

/deep/ .el-form-item:nth-last-child(1) {
  margin-bottom: 0;
}

/deep/ .el-form-item__error {
  left: 20px;
}

/deep/.el-input-group__prepend {
  border: none;
  padding: 0 10px;
}

.el-button {
  margin-top: 20px;
  width: 95%;
  border-radius: 10px;
}

.login {
  background-color: #fff;
  height: 1200px;
  width: 100%;
  overflow: auto;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  background-image: url(../assets/img/bg1.png);
  position: relative;
}

.border-bg {
  width: 85%;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;
  border: 1px solid #fff;
  padding: 25px;
  border-radius: 30px;
}

.gift-info {
  top: 680px;
}

.gift-img {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 80%;
  margin: 0 auto;
}

.gift-img img {
  width: 50px;
  height: 50px;
}

.gift-text {
  margin-top: 15px;
  text-align: center !important;
}

.login-form {
  top: 860px;
}

.form-bg {
  background-color: #f5f5f5;
  border-radius: 10px;
  /* 设置圆角，20px 为圆角半径 */
  padding: 5px 0;
}

.getCode {
  width: 100% !important;
  margin-top: 5px;
  display: flex;
  justify-content: center;
}

.rule {
  text-align: left;
  color: #d4792f;
  font-size: 15px;
}

@media screen and (max-width: 1024px) {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  .el-button {
    width: 80%;
  }

  .border-bg {
    padding: 10px;
    border-radius: 15px;
  }

  .gift-img {
    width: 100%;
    justify-content: space-around;
  }

  .gift-info {
    top: 360px;
  }

  .login-form {
    top: 485px;
  }

  .login {
    height: 750px;
  }

  .btn {
    width: 100%;
    margin-top: 10px;
  }

  .rule {
    text-align: left;
    color: #d4792f;
    font-size: 11px;
  }
}
</style>
